import { FC } from 'react'
import { Flex, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

interface Props {
  label: string
  helpText: string
  testId: string
}

const ColumnHelpTitle: FC<Props> = ({ label, helpText, testId }) => {
  return (
    <Flex align="center" gap="small">
      {label}
      <Tooltip title={helpText}>
        <QuestionCircleOutlined data-test-id={testId} />
      </Tooltip>
    </Flex>
  )
}

export default ColumnHelpTitle
